// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Window$OrcaPaymentPage from "../Window.bs.js";
import * as PaymentBody$OrcaPaymentPage from "../Utilities/PaymentBody.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as ApplePayTypes$OrcaPaymentPage from "../Types/ApplePayTypes.bs.js";
import * as GooglePayType$OrcaPaymentPage from "../Types/GooglePayType.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as ApplePayHelpers$OrcaPaymentPage from "../Utilities/ApplePayHelpers.bs.js";
import * as GooglePayHelpers$OrcaPaymentPage from "../Utilities/GooglePayHelpers.bs.js";
import * as EventListenerManager$OrcaPaymentPage from "../Utilities/EventListenerManager.bs.js";
import * as UpdateIntentHelpersNew$OrcaPaymentPage from "./UpdateIntentHelpersNew.bs.js";

var cvcWidgetNotFoundErrorType = "cvc_widget_not_found";

var cvcValidationErrorType = "cvc_validation";

function getCustomerSavedPaymentMethods(clientSecretRef, publishableKey, endpoint, logger, customPodUri, sdkAuthorizationRef, redirectionFlags, iframeRef, isUpdateIntentInProgress) {
  var applePaySessionRef = {
    contents: null
  };
  return Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.fetchCustomerPaymentMethodList(clientSecretRef.contents, publishableKey, logger, customPodUri, endpoint, true, Caml_option.some(Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationRef.contents))).then(function (customerDetails) {
                  var gPayClientOpt;
                  try {
                    gPayClientOpt = new google.payments.api.PaymentsClient({
                          environment: publishableKey.startsWith("pk_prd_") ? "PRODUCTION" : "TEST"
                        });
                  }
                  catch (raw_err){
                    var err = Caml_js_exceptions.internalToOCamlException(raw_err);
                    logger.setLogError("ERROR DURING LOADING GOOGLE PAY CLIENT - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)), "GOOGLE_PAY_SCRIPT", undefined, undefined, undefined, undefined, "GOOGLE_PAY");
                    gPayClientOpt = undefined;
                  }
                  var customerDetailsDict = Core__Option.getOr(Core__JSON.Decode.object(customerDetails), {});
                  var match = PaymentType$OrcaPaymentPage.itemToCustomerObjMapper(customerDetailsDict);
                  var isGuestCustomer = match[1];
                  var customerPaymentMethods = match[0];
                  customerPaymentMethods.sort(function (a, b) {
                        return Utils$OrcaPaymentPage.compareLogic(a.lastUsedAt, b.lastUsedAt);
                      });
                  var customerPaymentMethodsRef = {
                    contents: customerPaymentMethods
                  };
                  var applePayTokenRef = {
                    contents: ApplePayTypes$OrcaPaymentPage.defaultHeadlessApplePayToken
                  };
                  var googlePayTokenRef = {
                    contents: null
                  };
                  var isApplePayPresent = Core__Option.isSome(customerPaymentMethods.find(function (customerPaymentMethod) {
                            return customerPaymentMethod.paymentMethodType === "apple_pay";
                          }));
                  var isGooglePayPresent = Core__Option.isSome(customerPaymentMethods.find(function (customerPaymentMethod) {
                            return customerPaymentMethod.paymentMethodType === "google_pay";
                          }));
                  var canMakePayments;
                  try {
                    var session = window.ApplePaySession;
                    canMakePayments = (session == null) ? false : session.canMakePayments();
                  }
                  catch (exn){
                    canMakePayments = false;
                  }
                  var customerDefaultPaymentMethodRef = {
                    contents: customerPaymentMethods.filter(function (customerPaymentMethod) {
                            return customerPaymentMethod.defaultPaymentMethodSet;
                          })[0]
                  };
                  var getCustomerDefaultSavedPaymentMethodData = function () {
                    var defaultPaymentMethod = customerDefaultPaymentMethodRef.contents;
                    if (defaultPaymentMethod !== undefined) {
                      return defaultPaymentMethod;
                    } else {
                      return Utils$OrcaPaymentPage.handleFailureResponse("There is no default saved payment method data for this customer.", "no_data");
                    }
                  };
                  var getCustomerLastUsedPaymentMethodData = function () {
                    var lastUsedPaymentMethod = customerPaymentMethodsRef.contents[0];
                    if (lastUsedPaymentMethod !== undefined) {
                      return lastUsedPaymentMethod;
                    } else {
                      return Utils$OrcaPaymentPage.handleFailureResponse("No recent payments found for this customer.", "no_data");
                    }
                  };
                  var confirmWithCVCOrPaymentSession = function (body, payload, paymentType, requiresCvv) {
                    var redirect = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(payload), "redirect", "if_required");
                    var payloadDict = Utils$OrcaPaymentPage.getDictFromJson(payload);
                    var confirmParams = Utils$OrcaPaymentPage.getDictFromDict(payloadDict, "confirmParams");
                    confirmParams["redirect"] = redirect;
                    var id = Core__Option.flatMap(payloadDict["id"], Core__JSON.Decode.string);
                    var hasCvc = payloadDict["cvc"];
                    if (Core__Option.isSome(hasCvc)) {
                      var cvcString = Utils$OrcaPaymentPage.getStringFromOptionalJson(hasCvc, "");
                      var isValidCvc = /^\d{3,4}$/.test(cvcString);
                      if (isValidCvc) {
                        body.push([
                              "card_cvc",
                              cvcString
                            ]);
                        return PaymentHelpers$OrcaPaymentPage.paymentIntentForPaymentSession(body, paymentType, payloadDict, publishableKey, clientSecretRef.contents, logger, customPodUri, redirectionFlags, undefined, Caml_option.some(Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationRef.contents)), undefined);
                      } else {
                        return Promise.resolve(Utils$OrcaPaymentPage.handleFailureResponse("CVC must be a string of 3 to 4 numeric digits", cvcValidationErrorType));
                      }
                    }
                    if (!requiresCvv) {
                      return PaymentHelpers$OrcaPaymentPage.paymentIntentForPaymentSession(body, paymentType, payloadDict, publishableKey, clientSecretRef.contents, logger, customPodUri, redirectionFlags, undefined, Caml_option.some(Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationRef.contents)), undefined);
                    }
                    var idVal = Core__Option.getOr(id, "");
                    if (Core__Option.isNone(id)) {
                      return Promise.resolve(Utils$OrcaPaymentPage.handleFailureResponse("INTEGRATION ERROR: Mount the CVC widget with a valid ID or pass the required CVC value.", "invalid_request"));
                    } else if (Utils$OrcaPaymentPage.isWidgetPresent(iframeRef, idVal)) {
                      var requiresCvv$1 = true;
                      var payloadDict$1 = Utils$OrcaPaymentPage.getDictFromJson(payloadDict);
                      var redirect$1 = Utils$OrcaPaymentPage.getString(payloadDict$1, "redirect", "if_required");
                      return new Promise((function (resolve, param) {
                                    var handleCVCWidgetConfirmResponse = function ($$event) {
                                      var eventDataDict = Utils$OrcaPaymentPage.getDictFromJson($$event.data);
                                      var responseData = eventDataDict["cvcWidgetConfirmResponse"];
                                      if (responseData !== undefined) {
                                        var responseDataDict = Utils$OrcaPaymentPage.getDictFromJson(responseData);
                                        var returnUrl = Utils$OrcaPaymentPage.getString(responseDataDict, "returnUrl", "");
                                        var data = responseDataDict["data"];
                                        if (data !== undefined) {
                                          if (redirect$1 === "always") {
                                            window.location.replace(returnUrl);
                                            return ;
                                          } else {
                                            return resolve(data);
                                          }
                                        } else {
                                          return resolve(responseData);
                                        }
                                      }
                                      var errorResponseData = eventDataDict["cvcWidgetConfirmErrorResponse"];
                                      if (errorResponseData !== undefined) {
                                        return resolve(errorResponseData);
                                      }
                                      
                                    };
                                    EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", handleCVCWidgetConfirmResponse, "onCVCWidgetConfirmResponse");
                                    var confirmParams = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                                          [
                                            "body",
                                            Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body)
                                          ],
                                          [
                                            "payload",
                                            payloadDict
                                          ],
                                          [
                                            "paymentType",
                                            paymentType
                                          ],
                                          [
                                            "publishableKey",
                                            publishableKey
                                          ],
                                          [
                                            "clientSecret",
                                            clientSecretRef.contents
                                          ],
                                          [
                                            "requiresCvv",
                                            requiresCvv$1
                                          ],
                                          [
                                            "redirect",
                                            redirect$1
                                          ]
                                        ]);
                                    var message = Object.fromEntries([[
                                            "requestCVCConfirm",
                                            confirmParams
                                          ]]);
                                    var iframe = Utils$OrcaPaymentPage.getWidgetIframe(iframeRef, idVal);
                                    if (iframe !== undefined) {
                                      return Window$OrcaPaymentPage.iframePostMessage(Caml_option.valFromOption(iframe), message);
                                    } else {
                                      return resolve(Utils$OrcaPaymentPage.handleFailureResponse("INTEGRATION ERROR: Mount the CVC widget with a valid ID or pass the required CVC value.", cvcWidgetNotFoundErrorType));
                                    }
                                  }));
                    } else {
                      return Promise.resolve(Utils$OrcaPaymentPage.handleFailureResponse("INTEGRATION ERROR: Mount the CVC widget with a valid ID or pass the required CVC value.", cvcWidgetNotFoundErrorType));
                    }
                  };
                  var confirmWithCustomerDefaultPaymentMethod = function (payload) {
                    if (isUpdateIntentInProgress.contents) {
                      return Promise.resolve(UpdateIntentHelpersNew$OrcaPaymentPage.confirmBlockedResponseForSession());
                    }
                    var defaultPaymentMethod = customerDefaultPaymentMethodRef.contents;
                    if (defaultPaymentMethod === undefined) {
                      return Promise.resolve(Utils$OrcaPaymentPage.handleFailureResponse("There is no default saved payment method data for this customer.", "no_data"));
                    }
                    var paymentToken = defaultPaymentMethod.paymentToken;
                    var paymentMethod = defaultPaymentMethod.paymentMethod;
                    var paymentMethodType = Core__Option.getOr(defaultPaymentMethod.paymentMethodType, "");
                    var paymentType = PaymentHelpers$OrcaPaymentPage.getPaymentType(paymentMethodType);
                    var body = [
                      [
                        "payment_method",
                        paymentMethod
                      ],
                      [
                        "payment_token",
                        paymentToken
                      ]
                    ];
                    if (paymentMethodType !== "") {
                      body.push([
                            "payment_method_type",
                            paymentMethodType
                          ]);
                    }
                    return confirmWithCVCOrPaymentSession(body, payload, paymentType, defaultPaymentMethod.requiresCvv);
                  };
                  var confirmWithLastUsedPaymentMethod = function (payload) {
                    if (isUpdateIntentInProgress.contents) {
                      return Promise.resolve(UpdateIntentHelpersNew$OrcaPaymentPage.confirmBlockedResponseForSession());
                    }
                    var lastUsedPaymentMethod = customerPaymentMethodsRef.contents[0];
                    if (lastUsedPaymentMethod === undefined) {
                      return Promise.resolve(Utils$OrcaPaymentPage.handleFailureResponse("No recent payments found for this customer.", "no_data"));
                    }
                    if (lastUsedPaymentMethod.paymentMethodType === "apple_pay") {
                      return new Promise((function (resolve, param) {
                                    var processPayment = function (payment) {
                                      var token = payment.token;
                                      var billingContactDict = Utils$OrcaPaymentPage.getDictFromJson(payment.billingContact);
                                      var shippingContactDict = Utils$OrcaPaymentPage.getDictFromJson(payment.shippingContact);
                                      var completeApplePayPayment = function () {
                                        var applePayBody = ApplePayHelpers$OrcaPaymentPage.getApplePayFromResponse(token, billingContactDict, shippingContactDict, undefined, [], true, undefined);
                                        var requestBody = PaymentUtils$OrcaPaymentPage.appendedCustomerAcceptance(isGuestCustomer, "NONE", applePayBody, undefined);
                                        var paymentMethodType = Core__Option.getOr(lastUsedPaymentMethod.paymentMethodType, "");
                                        var paymentType = PaymentHelpers$OrcaPaymentPage.getPaymentType(paymentMethodType);
                                        return PaymentHelpers$OrcaPaymentPage.paymentIntentForPaymentSession(requestBody, paymentType, payload, publishableKey, clientSecretRef.contents, logger, customPodUri, redirectionFlags, undefined, Caml_option.some(Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationRef.contents)), undefined).then(function (val) {
                                                    resolve(val);
                                                    return Promise.resolve();
                                                  });
                                      };
                                      completeApplePayPayment();
                                    };
                                    ApplePayHelpers$OrcaPaymentPage.startApplePaySession(applePayTokenRef.contents.paymentRequestData, applePaySessionRef, applePayTokenRef.contents.sessionTokenData, logger, processPayment, resolve, clientSecretRef.contents, publishableKey, undefined, undefined);
                                  }));
                    }
                    if (lastUsedPaymentMethod.paymentMethodType === "google_pay") {
                      if (gPayClientOpt !== undefined) {
                        var paymentDataRequest = googlePayTokenRef.contents;
                        return Core__Promise.$$catch(gPayClientOpt.loadPaymentData(paymentDataRequest).then(function (json) {
                                        logger.setLogInfo("Payment Data Filled: New Payment Method", "PAYMENT_DATA_FILLED", undefined, undefined, undefined, undefined, "GOOGLE_PAY");
                                        var completeGooglePayPayment = function () {
                                          var body = GooglePayHelpers$OrcaPaymentPage.getGooglePayBodyFromResponse(json, isGuestCustomer, undefined, [], undefined, true, undefined, undefined);
                                          var paymentMethodType = Core__Option.getOr(lastUsedPaymentMethod.paymentMethodType, "");
                                          var paymentType = PaymentHelpers$OrcaPaymentPage.getPaymentType(paymentMethodType);
                                          return PaymentHelpers$OrcaPaymentPage.paymentIntentForPaymentSession(body, paymentType, payload, publishableKey, clientSecretRef.contents, logger, customPodUri, redirectionFlags, undefined, Caml_option.some(Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationRef.contents)), undefined);
                                        };
                                        return completeGooglePayPayment();
                                      }), (function (err) {
                                      logger.setLogInfo(JSON.stringify(err), "GOOGLE_PAY_FLOW", undefined, undefined, "DEBUG", undefined, "GOOGLE_PAY");
                                      return Promise.resolve(Utils$OrcaPaymentPage.handleFailureResponse(JSON.stringify(err), "google_pay"));
                                    }));
                      }
                      logger.setLogInfo("GooglePay client unavailable for loadPaymentData", "GOOGLE_PAY_FLOW", undefined, undefined, "DEBUG", undefined, "GOOGLE_PAY");
                      return Promise.resolve(Utils$OrcaPaymentPage.handleFailureResponse("Google Pay is not available", "google_pay"));
                    }
                    var paymentToken = lastUsedPaymentMethod.paymentToken;
                    var paymentMethod = lastUsedPaymentMethod.paymentMethod;
                    var paymentMethodType = Core__Option.getOr(lastUsedPaymentMethod.paymentMethodType, "");
                    var paymentType = PaymentHelpers$OrcaPaymentPage.getPaymentType(paymentMethodType);
                    var isCustomerAcceptanceRequired = !lastUsedPaymentMethod.recurringEnabled;
                    var body = [
                      [
                        "payment_method",
                        paymentMethod
                      ],
                      [
                        "payment_token",
                        paymentToken
                      ]
                    ];
                    if (isCustomerAcceptanceRequired) {
                      body.push([
                            "customer_acceptance",
                            PaymentBody$OrcaPaymentPage.customerAcceptanceBody
                          ]);
                    }
                    if (paymentMethodType !== "") {
                      body.push([
                            "payment_method_type",
                            paymentMethodType
                          ]);
                    }
                    return confirmWithCVCOrPaymentSession(body, payload, paymentType, lastUsedPaymentMethod.requiresCvv);
                  };
                  var updateCustomerPaymentMethodsRef = function (isFilterApplePayOpt, isFilterGooglePayOpt) {
                    var isFilterApplePay = isFilterApplePayOpt !== undefined ? isFilterApplePayOpt : false;
                    var isFilterGooglePay = isFilterGooglePayOpt !== undefined ? isFilterGooglePayOpt : false;
                    var filterArray = [];
                    if (isFilterApplePay) {
                      filterArray.push("apple_pay");
                    }
                    if (isFilterGooglePay) {
                      filterArray.push("google_pay");
                    }
                    var updatedCustomerDetails = customerPaymentMethodsRef.contents.filter(function (customerPaymentMethod) {
                          return !filterArray.includes(Core__Option.getOr(customerPaymentMethod.paymentMethodType, ""));
                        });
                    customerPaymentMethodsRef.contents = updatedCustomerDetails;
                    customerDefaultPaymentMethodRef.contents = updatedCustomerDetails.filter(function (m) {
                            return m.defaultPaymentMethodSet;
                          })[0];
                  };
                  var isGooglePayUsable = isGooglePayPresent && Core__Option.isSome(gPayClientOpt);
                  if (isApplePayPresent && canMakePayments || isGooglePayUsable) {
                    return Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.fetchSessions(clientSecretRef.contents, publishableKey, undefined, undefined, logger, customPodUri, endpoint, undefined, undefined, Caml_option.some(Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationRef.contents))).then(function (sessionDetails) {
                                    var componentName = "headless";
                                    var dict = Utils$OrcaPaymentPage.getDictFromJson(sessionDetails);
                                    var sessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "Others");
                                    var applePaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "ApplePayObject");
                                    var applePayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(applePaySessionObj.sessionsToken, "ApplePay");
                                    var gPayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Gpay");
                                    var gPayTokenObj;
                                    gPayTokenObj = gPayToken.TAG === "OtherTokenOptional" ? gPayToken._0 : SessionsType$OrcaPaymentPage.defaultToken;
                                    var gPayobj = gPayTokenObj !== undefined ? gPayTokenObj : SessionsType$OrcaPaymentPage.defaultToken;
                                    var payRequest = Object.assign({}, GooglePayType$OrcaPaymentPage.baseRequest, {
                                          allowedPaymentMethods: Utils$OrcaPaymentPage.arrayJsonToCamelCase(gPayobj.allowed_payment_methods)
                                        });
                                    var isGooglePayReadyPromise;
                                    if (gPayClientOpt !== undefined) {
                                      try {
                                        isGooglePayReadyPromise = Core__Promise.$$catch(gPayClientOpt.isReadyToPay(payRequest).then(function (res) {
                                                  var dict = Utils$OrcaPaymentPage.getDictFromJson(res);
                                                  return Promise.resolve(Utils$OrcaPaymentPage.getBool(dict, "result", false));
                                                }), (function (err) {
                                                logger.setLogInfo(JSON.stringify(err), "GOOGLE_PAY_FLOW", undefined, undefined, "DEBUG", undefined, "GOOGLE_PAY");
                                                return Promise.resolve(false);
                                              }));
                                      }
                                      catch (raw_exn){
                                        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                                        logger.setLogInfo(JSON.stringify(exn), "GOOGLE_PAY_FLOW", undefined, undefined, "DEBUG", undefined, "GOOGLE_PAY");
                                        isGooglePayReadyPromise = Promise.resolve(false);
                                      }
                                    } else {
                                      isGooglePayReadyPromise = Promise.resolve(false);
                                    }
                                    Core__Promise.$$catch(isGooglePayReadyPromise.then(function (isGooglePayReady) {
                                              if (isGooglePayReady) {
                                                var paymentDataRequest = GooglePayType$OrcaPaymentPage.getPaymentDataFromSession(gPayTokenObj, componentName);
                                                googlePayTokenRef.contents = paymentDataRequest;
                                              } else {
                                                updateCustomerPaymentMethodsRef(undefined, true);
                                              }
                                              return Promise.resolve();
                                            }), (function (err) {
                                            logger.setLogInfo(JSON.stringify(err), "GOOGLE_PAY_FLOW", undefined, undefined, "DEBUG", undefined, "GOOGLE_PAY");
                                            return Promise.resolve();
                                          }));
                                    if (applePayToken.TAG === "ApplePayTokenOptional") {
                                      var optToken = applePayToken._0;
                                      var paymentRequest = ApplePayTypes$OrcaPaymentPage.getPaymentRequestFromSession(optToken, componentName);
                                      applePayTokenRef.contents = {
                                        paymentRequestData: paymentRequest,
                                        sessionTokenData: optToken
                                      };
                                    } else {
                                      updateCustomerPaymentMethodsRef(true, undefined);
                                    }
                                    return Promise.resolve({
                                                getCustomerDefaultSavedPaymentMethodData: getCustomerDefaultSavedPaymentMethodData,
                                                getCustomerLastUsedPaymentMethodData: getCustomerLastUsedPaymentMethodData,
                                                confirmWithCustomerDefaultPaymentMethod: confirmWithCustomerDefaultPaymentMethod,
                                                confirmWithLastUsedPaymentMethod: confirmWithLastUsedPaymentMethod
                                              });
                                  }), (function (param) {
                                  updateCustomerPaymentMethodsRef(true, true);
                                  return Promise.resolve({
                                              getCustomerDefaultSavedPaymentMethodData: getCustomerDefaultSavedPaymentMethodData,
                                              getCustomerLastUsedPaymentMethodData: getCustomerLastUsedPaymentMethodData,
                                              confirmWithCustomerDefaultPaymentMethod: confirmWithCustomerDefaultPaymentMethod,
                                              confirmWithLastUsedPaymentMethod: confirmWithLastUsedPaymentMethod
                                            });
                                }));
                  } else {
                    updateCustomerPaymentMethodsRef(true, true);
                    return Promise.resolve({
                                getCustomerDefaultSavedPaymentMethodData: getCustomerDefaultSavedPaymentMethodData,
                                getCustomerLastUsedPaymentMethodData: getCustomerLastUsedPaymentMethodData,
                                confirmWithCustomerDefaultPaymentMethod: confirmWithCustomerDefaultPaymentMethod,
                                confirmWithLastUsedPaymentMethod: confirmWithLastUsedPaymentMethod
                              });
                  }
                }), (function (err) {
                var exceptionMessage = JSON.stringify(Utils$OrcaPaymentPage.formatException(err));
                return Promise.resolve(Utils$OrcaPaymentPage.handleFailureResponse(exceptionMessage, "server_error"));
              }));
}

export {
  cvcWidgetNotFoundErrorType ,
  cvcValidationErrorType ,
  getCustomerSavedPaymentMethods ,
}
/* Utils-OrcaPaymentPage Not a pure module */
